import {
    REQUEST,
    COLLAPSE_CONTENT,
    BREADCRUMBS,
    SET_LANGUAGE,
    LOADING_STOP,
    LOADING_START
} from "../constants/actions/global";

export const requestStart = () => ({
    type: REQUEST.START
});

export const requestSuccess = () => ({
    type: REQUEST.SUCCESS
});

export const requestErorr = msg => ({
    type: REQUEST.ERROR,
    payload: msg
});

export const collapseContent = bool => ({
    type: COLLAPSE_CONTENT,
    payload: bool
});

export const breadCrumbsSet = list => ({
    type: BREADCRUMBS.SET,
    payload: list
});

export const setLanguage = lang => ({
    type: SET_LANGUAGE,
    payload: lang
});

export const startGlobalLoading = () => ({
    type: LOADING_START
});

export const stopGlobalLoading = () => ({
    type: LOADING_STOP
});
